import React from 'react'
import { Dropdown } from 'semantic-ui-react'

import './style.css'

/* Title Case labels match the Admin → Email authentication page (DomainRow). */
const STATUS_LABEL = {
  validated: 'Validated',
  failed: 'Failed',
  pending: 'Pending',
}

function DomainDropdown({ domains, selectedEmailDomain, handleDomainChange, style, disabled }) {
  /* Sort: validated first (alphabetical), then unverified (failed + pending,
     alphabetical within their group). Pickable items always come first so users
     don't scroll past unselectable rows. */
  const sortedDomains = [...domains].sort((a, b) => {
    const aValid = a.status === 'validated' ? 0 : 1
    const bValid = b.status === 'validated' ? 0 : 1
    if (aValid !== bValid) {
      return aValid - bValid
    }
    return a.text.localeCompare(b.text)
  })

  return (
    <Dropdown
      floating
      button
      className="basic domain-dropdown"
      style={style}
      disabled={disabled}
      value={selectedEmailDomain}
      text={selectedEmailDomain}
    >
      <Dropdown.Menu className="left domain-dropdown-menu">
        {sortedDomains.map((item) => {
          const isValid = item.status === 'validated'
          return (
            <Dropdown.Item
              key={item.value}
              text={item.text}
              value={item.value}
              disabled={!isValid}
              description={isValid ? undefined : STATUS_LABEL[item.status]}
              onClick={() => {
                if (isValid) {
                  handleDomainChange({ target: { innerText: item.value } })
                }
              }}
            />
          )
        })}
        <Dropdown.Divider className="domain-dropdown-divider" />
        <a
          href="/settings/email/"
          target="_blank"
          rel="noopener noreferrer"
          role="option"
          className="item domain-dropdown-add"
        >
          <i aria-hidden="true" className="icon far fa-plus" />
          Add a domain
        </a>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DomainDropdown



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DomainDropdown/index.js